import {
  call, put, select, takeEvery, takeLeading,
} from 'redux-saga/effects';
import {
  GET_MRD_CONTACTS_REQUEST,
  ASSOCIATE_CONTACTS_REQUEST,
} from '../actions/types/ContactManagementActionTypes';
import {
  getMrdContactsSuccessActionCreator,
  getMrdContactsFailureActionCreator,
  associateMrdContactsSuccessActionCreator,
  associateMrdContactsFailureActionCreator,
} from '../actions/ContactManagementActions';
import {
  apiFetchMrdContactList,
  apiAssociateContactToImpc,
} from '../../api/ContactManagementAPI';
import { showNotification } from '../../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../locales/locales';
import { languageSelector } from '../../../../../../common/redux/selectors/languageSelector';

function* getMrdContactsWorker(action) {
  try {
    const res = yield call(apiFetchMrdContactList, action.payload);
    yield put(getMrdContactsSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getMrdContactsFailureActionCreator(error));
  }
}

function* associateMrdContactsWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiAssociateContactToImpc, action.payload);
    yield put(associateMrdContactsSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.contacts.associate.success'),
    }));
  } catch (error) {
    yield put(associateMrdContactsFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error?.response?.data?.message || 'request failed',
    }));
  }
}

function* contactManagementWatcher() {
  yield takeEvery(GET_MRD_CONTACTS_REQUEST, getMrdContactsWorker);
  yield takeLeading(ASSOCIATE_CONTACTS_REQUEST, associateMrdContactsWorker);
}

export default contactManagementWatcher;
export {
  getMrdContactsWorker,
  associateMrdContactsWorker,
};
